module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "background-empty-state.a5413910.svg";